import styled from 'styled-components';
const BaseInformationStyled = styled.div`
  border-radius: 12px;
  background-color: #fff;
  margin-bottom: 4px;
  .box {
    display: flex;
    padding: 24px 32px 29px;
    /* gap:  */
    .item {
      flex: 1;
      .up {
        font-size: 12px;
        line-height: 20px;
        color: #212121;
      }
      .down {
        font-size: 16px;
        line-height: 20px;
        margin-top: 6px;
        color: #212121;
      }
    }
    .icon_box {
      position: relative;
      .user_icon {
        position: absolute;
        top: 20px;
        right: 5px;
        z-index: 1;
        svg {
          margin-right: 5px;
        }
      }
    }
  }
`;
export default BaseInformationStyled;
